/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { AnalyticsService } from './@core/utils/analytics.service'
import { SeoService } from './@core/utils/seo.service'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'ngx-app',
  styleUrls: ['app.component.scss'],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }
}

